/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_TransferAgent_TransferAgentManagedCompanyDto } from '../models/Wealthlane_CustomerService_Dtos_TransferAgent_TransferAgentManagedCompanyDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TransferAgentCompanyService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_TransferAgent_TransferAgentManagedCompanyDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppTransferAgentCompanyTransferAgentManagedCompanies(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_TransferAgent_TransferAgentManagedCompanyDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/transfer-agent-company/transfer-agent-managed-companies',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
